<template>
  <div class="page-ticket">
    <div class="form-horizontal">
      <user-view :user="user"></user-view>
    </div>
    <div class="clearfix"></div>
    <ticket-view :ticket="ticket"></ticket-view>
    <div class="row" style="margin-top:20px;text-align:center;">
      <div class="col-sm-4 col-sm-offset-4">
        <div class="btn-group">
          <button class="btn btn-primary" @click="print=true">打印</button>
          <button class="btn btn-primary" v-if="!ticket.hasPay" @click="$router.push(`/pay/ticket/${ticket.idView}`)">支付</button>
        </div>
      </div>
    </div>
    <modal v-model="print" title="洗衣单打印" size="sm">
      <ticket-print id="printMe" :ticket="ticket" ref="print" v-if="!showImage"></ticket-print>
      <img v-else :src="imageBase64Data">
      <div slot="footer">
        <btn @click="print=false">取消</btn>
        <btn @click="saveImage">显示图片</btn>
        <btn type="primary" @click="doPrint">确认打印</btn>
      </div>
    </modal>
  </div>
</template>

<script>
import TicketView from '@/components/views/Ticket'
import * as TYPES from '../store/types'
import UserView from '@/components/views/Vip'
import TicketPrint from '@/components/prints/TicketPrint'

import html2canvas from 'html2canvas'

export default {
  components: {
    TicketView,
    UserView,
    TicketPrint
  },
  data() {
    return {
      imageBase64Data: '',
      showImage: false,
      showPay: false,
      print: false,
      cssText: `
    .print-box {
      /* full-width container */
      position: relative;
      width: auto;
      /* control here the container left/right margins */
      margin: 0;
      padding: 0;
      overflow: hidden;
    }
    button {
      background-color: #f0f0f0;
      border: solid 1px #ccc;
      padding: 5px 10px;
      font-size: 12px;
    }
    pre {
      color: #c7254e;
    }
  `
    }
  },
  methods: {
    saveImage() {
      let canvas = document.querySelector('#printMe')
      let that = this
      html2canvas(canvas, {scale: 2, logging: false, useCORS: true}).then(function(canvas) {
        let type = 'png'
        let imgData = canvas.toDataURL(type)
        console.log(imgData)
        that.imageBase64Data = imgData
        that.showImage = true
                // 照片格式处理
        // let _fixType = function(type) {
        //   type = type.toLowerCase().replace(/jpg/i, 'jpeg')
        //   let r = type.match(/png|jpeg|bmp|gif/)[0]
        //   return 'image/' + r
        // }
        // imgData = imgData.replace(_fixType(type), 'image/octet-stream')
        // let filename = that.ticket.idView + '.' + type
        // that.saveFile(imgData, filename)
      })
    },
    saveFile(data, filename) {
      let saveLink = document.createElementNS('http://www.w3.org/1999/xhtml', 'a')
      saveLink.href = data
      saveLink.download = filename

      let event = document.createEvent('MouseEvents')
      event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      saveLink.dispatchEvent(event)
    },
    doPrint() {
      this.$printTicket(this.ticket)
      .then(() => {
        this.print = false
        this.$notify({
          type: 'success',
          content: '操作成功！'
        })
      })
      .catch(err => {
        this.$notify({
          type: 'danger',
          content: '操作失败！' + err.toString()
        })
      })
    }
  },
  computed: {
    ticket() {
      return this.$store.state.tickets.payment.ticket
    },
    user() {
      if (this.$store.state.tickets.payment.ticket.user === undefined) {
        return {
          phone: '',
          profile: {
            name: '',
            phone: '',
            address: '',
            sex: '',
            vipID: '',
            balance: ''
          }
        }
      } else {
        return this.$store.state.tickets.payment.ticket.user
      }
    }
  },
  created() {
    this.$store.dispatch(TYPES.DO_GET_TICKET, this.$route.params.ticket)
  }
}
</script>

<style>
img {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Ticket.vue